export const helpers_url = {

    'delete_parameter' : function (name, update_url = false, queryString = '')
    {
        let parameters = this.get_parameters(queryString);
        parameters.delete(name);

        if (update_url)
            this.update_url(parameters, queryString);

        return parameters;
    },

    'get_parameters' : function(queryString)
    {
        queryString = queryString || window.location.search;
        queryString = encodeURI(queryString);
        queryString = decodeURI(queryString);
        return new URLSearchParams(queryString);
    },


    'set_parameter' : function(name, value, update_url = false, queryString = '')
    {
        let parameters = this.get_parameters(queryString);
        parameters.set(name, value);

        if (update_url)
            this.update_url(parameters, queryString);

        return parameters;
    },

    /**
     *
     * @param {URLSearchParams} parameters
     * @param {string} queryString
     * @param {boolean} reload
     */
    'update_url' : function(parameters, queryString = '', reload = false)
    {
        let url = queryString || window.location.pathname;
        if (parameters.size)
            url += '?'+parameters;
        window.history.replaceState({}, '', url);
    }

}
